/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ThermographicInspectionRecordReport from "./ThermographicInspectionRecordReport";
import { DatabaseService } from "pages/thermography/stores/DatabaseService";
import { Button } from "react-bootstrap";

export default function ThermographicInspectionRecordReportPage() {
    const { codigo } = useParams<{ codigo: string }>();
    const navigate = useNavigate();
    const location = useLocation() as any;
    const { t } = useTranslation();
    const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });

    const dbService = DatabaseService.getInstance();

    const stateRecord = location.state?.anomalyRecord;
    const stateDeltaT = location.state?.deltaT ?? 0;

    const anomalyRecord = useMemo(() => {
        if (stateRecord) return stateRecord;

        const records = dbService.getAnomalyRecords();
        return records.find((x: any) => String(x.id) === String(codigo)) ?? null;
    }, [stateRecord, codigo]);


    const powerStations = useMemo(
        () => dbService.getPowerStations().sort((a: any, b: any) => a.name.localeCompare(b.name)),
        []
    );
    const equipments = useMemo(() => dbService.getEquipments(), []);
    const inspectionRoutes = useMemo(() => dbService.getInspectionRecords(), []);
    const thermographers = useMemo(() => dbService.getThermographers(), []);

    const { equipmentsFiltered, inspectionRoutesFiltered, equipmentType } = useMemo(() => {
        if (!anomalyRecord) return { equipmentsFiltered: [], inspectionRoutesFiltered: [], equipmentType: "" };

        const ps = powerStations.find((p: any) => p.id == anomalyRecord.plant.id);
        const equipmentsFiltered = ps ? equipments.filter((e: any) => e.plant.id == ps.id) : [];
        const inspectionRoutesFiltered = ps ? inspectionRoutes.filter((r: any) => r?.plant.id == ps.id) : [];

        const eq = equipments.find((e: any) => e.id == anomalyRecord.equipment.id);
        const equipmentType = eq ? `${eq.code}` : "";

        return { equipmentsFiltered, inspectionRoutesFiltered, equipmentType };
    }, [anomalyRecord, powerStations, equipments, inspectionRoutes]);

    if (!anomalyRecord) {
        return (
            <div className="p-3">
                <p>{tt("pages.thermography.thermographicInspectionRecordReportPage.notFound")}</p>
                <Button variant="outline-primary" onClick={() => navigate(-1)}>
                    {tt("pages.thermography.thermographicInspectionRecordReportPage.back")}
                </Button>
            </div>
        );
    }

    return (
        <div>
            <div className="d-print-none p-2 d-flex gap-2 justify-content-end">
                <Button variant="outline-primary" onClick={() => navigate(-1)}>
                    {tt("pages.thermography.thermographicInspectionRecordReportPage.back")}
                </Button>
                <Button variant='primary' onClick={() => window.print()}>
                    {tt("pages.thermography.thermographicInspectionRecordReportPage.print")}
                </Button>
            </div>

            <ThermographicInspectionRecordReport
                anomalyRecord={anomalyRecord}
                powerStations={powerStations}
                equipmentsFiltered={equipmentsFiltered}
                inspectionRoutesFiltered={inspectionRoutesFiltered}
                thermographers={thermographers}
                equipmentType={equipmentType}
            />
        </div>
    );
}
